import { ModalProvider } from 'contexts/ModalContext'
import ModalManager from 'contexts/ModalManager'
import { TitleProvider } from 'contexts/TitleContext'
import { UserProvider } from 'contexts/UserContext'
import { ProjectsProvider } from 'contexts/ProjectsContext'
import { CompanyProvider } from 'contexts/CompanyContext'
import { LanguageProvider } from 'contexts/LanguageContext'
import 'i18n'
import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './pages/App'

// En producción los console.log de depuración no se muestran: varios vuelcan
// usuarios, formularios o respuestas de la API. console.error/warn se mantienen.
if (process.env.NODE_ENV === 'production') {
  console.log = () => {}
}

// Este archivo es el punto de entrada principal de la aplicación.
// Aquí se configura el renderizado inicial y los contextos globales.
ReactDOM.createRoot(document.getElementById('root')).render(
  // Modo estricto de React para detectar problemas y advertencias, se aplica automáticamente durante el desarrollo, en producción no
  <React.StrictMode>
    {/* Proveedor global del idioma seleccionado en el panel */}
    <LanguageProvider>
      {/* Proveedor global del estado del usuario */}
      <UserProvider>
        {/* Proveedor global para gestionar el título de la página actual */}
        <TitleProvider>
          {/* Proveedor global para gestionar los modal */}
          <ModalProvider>
            {/* Proveedor global para gestionar el proyecto seleccionado */}
            <ProjectsProvider>
              {/* Proveedor global para gestionar la empresa seleccionada (admins pueden cambiarla) */}
              <CompanyProvider>

                {/* Componente que controla los modales */}
                <ModalManager />

                {/* Componente principal de la aplicación */}
                <App />
              </CompanyProvider>
            </ProjectsProvider>
          </ModalProvider>
        </TitleProvider>
      </UserProvider>
    </LanguageProvider>
  </React.StrictMode>
)
